import { useState } from "react"
import { FullScreenModal } from "../../../utility/FullScreenModal"
import { SystemSS } from "../../../components/SystemSS"

export const FacilitiesBase = () => {
     const [showModal, setShowModal] = useState(false)
     const [modalContent, setModalContent] = useState({ contentType: '', category: '', index: 1 })
     const handleOpenModal = (contentType, category, index, maxIndex) => {
         setModalContent({ contentType, category, index, maxIndex })
         setShowModal(true)
     }
     const handleCloseModal = () => {
         setModalContent({ contentType: '', category: '', index: 0 })
         setShowModal(false)
     }
    return (
        <>
            {' '}
            <section className=''>
                <div className='flex justify-center '>
                    <img
                        className=''
                        alt='confine'
                        src={`${process.env.PUBLIC_URL}/images/system/system-facilities-fr.webp`}
                    />
                </div>
                <div className='text-pbnavy font-kiwi font-bold text-sub md:text-base text-shadow-white w-full md:w-4/5 px-4 md:px-0 mx-auto mt-12'>
                    <p>
                        Sur l'île du Squelette, qui est la base de Marona et de ses compagnons, vos alliés peuvent gérer
                        les diverses <span className="text-pborange">installations</span> pour fournir différents services. Pour débloquer une nouvelle
                        installation, il vous suffit de <span className="text-pborange">créer une unité de la classe requise</span> dans Création persos.
                    </p>
                    <SystemSS
                        mediaItems={[
                            {
                                modalId: 'facilities',
                                index: 1,
                            },
                        ]}
                        handleOpenModal={handleOpenModal}
                    />{' '}
                    <p>
                        Par exemple, il y a une Boutique dans laquelle vous pouvez acheter des objets, ainsi qu'une
                        Buvette qui vous permet de répartir l'EXP entre vos alliés. D'autres installations vous
                        permettent de renforcer vos unités, comme Création de donjon, Synthèse, Éveil / Réincarnation,
                        Titres et ainsi de suite, ce qui multiplie quasiment à l'infini les opportunités de vous
                        amuser !
                    </p>{' '}
                    <br />
                    <p>
                        De plus, quand vous augmentez le niveau de la Boutique, les objets disponibles à l'achat
                        <span className="text-pborange"> reçoivent une amélioration</span>. D'autres installations s'améliorent aussi quand vous faites monter
                        de niveau vos unités alliées. Veillez à créer et à faire progresser différentes unités, de
                        manière à pouvoir utiliser les diverses fonctionnalités de l'île du Squelette et à tirer le
                        maximum de votre partie !
                    </p>
                </div>
            </section>{' '}
            <FullScreenModal
                showModal={showModal}
                modalContent={modalContent}
                setModalImage
                handleCloseModal={handleCloseModal}
                setModalContent={setModalContent}
                maxIndex={1}
            />
        </>
    )
                
}